import { testimonials } from '@/mocks/testimonials';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-accent-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-accent-700 uppercase tracking-wider">
              Community Verified
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
            Trusted by Shoppers
            <br />
            <span className="text-foreground-400">Around the World</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto">
            Real feedback from real users who rely on our spreadsheets daily.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {t.text}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}